(() => {
  function boot(root=document){
    root.querySelectorAll('[data-wn-lcompare-select]').forEach(button=>{
      if(button.dataset.wnReady==='true')return;button.dataset.wnReady='true';
      button.addEventListener('click',()=>{
        const value=button.dataset.optionValue;const position=button.dataset.optionPosition;
        const smart=[...document.querySelectorAll('wn-product-form [data-wn-guide-option]')].find(item=>item.dataset.wnGuidePosition===position&&item.dataset.wnGuideValue===value);
        if(smart){smart.click()}else{
          const native=document.querySelector(`wn-product-form [data-option-position="${CSS.escape(position)}"] [data-option-value="${CSS.escape(value)}"]`);
          native?.click();
        }
        document.querySelector('.wn-product-buybox')?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      });
    });
  }
  document.addEventListener('shopify:section:load',e=>boot(e.target));if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
})();
